export default __webpack_public_path__ + "static/media/ic-irr-sprayline.86856f1c.svg";